import { DOMAIN_ERROR_CODES, DomainError, SYNC_ERROR_CODES, SyncError, TRANSPORT_ERROR_CODES, TransportError, } from "@econ-v1/domain";
export function serializeClientError(error) {
    return error.toJSON();
}
export function deserializeClientError(value) {
    if (!isSerializableClientError(value))
        throw new TypeError("Invalid RPC error");
    switch (value.kind) {
        case "domain":
            return new DomainError(errorOptions(value));
        case "sync":
            return new SyncError(errorOptions(value));
        case "transport":
            return new TransportError(errorOptions(value));
    }
}
export function isSerializableClientError(value) {
    if (!isJsonObject(value) || typeof value.code !== "string" || typeof value.kind !== "string" || typeof value.message !== "string") {
        return false;
    }
    if (value.details !== undefined && !isJsonObject(value.details))
        return false;
    switch (value.kind) {
        case "domain":
            return includesCode(DOMAIN_ERROR_CODES, value.code);
        case "sync":
            return includesCode(SYNC_ERROR_CODES, value.code);
        case "transport":
            return includesCode(TRANSPORT_ERROR_CODES, value.code);
        default:
            return false;
    }
}
export function isJsonValue(value) {
    if (value === null || typeof value === "boolean" || typeof value === "string")
        return true;
    if (typeof value === "number")
        return Number.isFinite(value);
    if (Array.isArray(value))
        return value.every(isJsonValue);
    return isJsonObject(value);
}
export function isJsonObject(value) {
    return isPlainObject(value) && Object.values(value).every(isJsonValue);
}
function errorOptions(value) {
    return value.details === undefined
        ? { code: value.code, message: value.message }
        : { code: value.code, details: value.details, message: value.message };
}
function includesCode(codes, value) {
    return codes.includes(value);
}
function isPlainObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value) && Object.getPrototypeOf(value) === Object.prototype;
}
//# sourceMappingURL=errors.js.map